import * as TYPES from '../../store/types'

const state = {
  customers: [],
  customers_metadata: {},
  readOnly: false,
}

/* eslint-disable no-param-reassign */
const mutations = {
  [TYPES.CUSTOMERS_SET_DATA](st, obj) {
    if (obj.customers) {
      st.customers = obj.customers
    }

    if (obj.metadata) {
      st.customers_metadata = obj.metadata
    }

    st.readOnly = !!obj.readOnly
  },
}

const actions = {
  customersSetData({ commit }, obj) {
    commit(TYPES.CUSTOMERS_SET_DATA, obj)
  },
}

const module = {
  state,
  mutations,
  actions,
}

export default { module }
